import { useState, useEffect } from 'react';
import { getConfiguration, Configuration } from '@sas/nova-core/config';
import { useMounted } from '../../hooks/useMounted';

export const useConfig = function () {
  const [config, setConfig] = useState<Configuration | null>(null);
  const mounted = useMounted();

  useEffect(() => {
    getConfiguration().then((config) => {
      if (!mounted.current) return;
      setConfig(config);
    });
  }, [mounted]);

  return config;
};
